import React from 'react';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import {useTranslation} from 'react-i18next';

import './VideoResumeCountdown.scss';

momentDurationFormatSetup(moment);

const VideoResumeCountdown = ({remaining}) => {
  const {t} = useTranslation();

  const countdown = moment.duration(remaining, 'seconds').format('h[h]mm[m]ss[s]');

  return (
    <div className={`video-resume-countdown${remaining > 3 ? ' show' : ''}`}>
      {t('reprise-de-la-lecture-dans')}
      <br />
      {countdown}
    </div>
  );
};

export default VideoResumeCountdown;
